// extracted by css-extract-rspack-plugin
export default {"customRiskScoreDrawer":"c32tkK_VeZUEEpDP","scoresListContainer":"HWt3TTEWaGosZjTY","scoreItem":"SAamDoCn8UgX8LDu","scoreRangeLabel":"XzoIQbJA9gA3I83a"};